import styled from 'styled-components';
import {
  Dialog as MaterialDialog,
  DialogContent as MaterialDialogContent,
} from '@material-ui/core';
import CreateUpdateForm from '../createUpdateForm';

export const Container = styled.div`
  width: 100%;
  height: 100%;
`;

export const Dialog = styled(MaterialDialog)`
  width: 100%;
`;

export const DialogContent = styled(MaterialDialogContent)`
  padding: 0 !important;
  width: 700px !important;
`;

export const StyledCreateUpdateForm = styled(CreateUpdateForm)`
  margin-bottom: 25px !important;
`;
